import api from '../plugin/request'
import Vue from 'vue'

/**
 * 上传单张图片
 * 参数：file：单张图片
 */
async function uploadFile(file) {
    return new Promise(async (resolve, reject) => {
        let formData = new FormData()
        formData.append('action', 'index_ossUpload')
        formData.append('img', file)
        const uploaderConfig = {
            headers: {
                'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime(),
            },
        }
        let res = await api.api('index_ossUpload', formData, 'post', uploaderConfig)
        if (res && res.code == 200) {
            resolve(res.data)
        } else if (res && res.code == 500) {
            alert(res.msg)
            resolve(false)
        } else {
            alert('文件上传失败')
            resolve(false)
        }
    })
}

/**
 * 上传图片数组
 * 参数：图片数组
 */
async function uploadFileList(fileList) {
    return new Promise(async (resolve, reject) => {
        let list = []
        for (let index = 0; index < fileList.length; index++) {
            let item = fileList[index]
            let res = await uploadFile(item)
            if (res) {
                list.push(res)
            } else {
                list.push(false)
            }
        }
        resolve(list)
    })
}

export { uploadFile, uploadFileList }
